import { useDispatch } from 'react-redux';
import { addPositiveToast } from 'modules/toastContainer';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { convertToString } from 'utils/datetime/date';
import JsPDF from 'jspdf';
import H2C from 'html2canvas';
import { OverflowMenu } from 'ui/actionMenu';
import { landscapeOrPortrait } from './utils';

type MoreActionsDropdownProps = {
  openSettingsModal: () => void;
};

export const MoreActionsDropdown = ({ openSettingsModal }: MoreActionsDropdownProps) => {
  const dispatch = useDispatch();

  const onExport = (type: string) => {
    const currentDate = convertToString(new Date());
    const fileName = `dashboard-${currentDate}.${type}`;
    const element = document.querySelector(`.react-grid-layout`);

    H2C(element as HTMLElement, {
      allowTaint: true,
      logging: false,
    }).then((canvas) => {
      const ctx = canvas.getContext('2d');

      if (ctx) {
        ctx.imageSmoothingEnabled = false;
        const { height, width } = canvas;
        const imageType = type === 'jpeg' ? 'image/jpeg' : 'image/png';
        const image = canvas.toDataURL(imageType, 1.0);

        if (type === 'pdf') {
          const pdf = new JsPDF({
            orientation: landscapeOrPortrait(width, height),
            unit: 'px',
            format: [width, height],
          });
          pdf.addImage(image, 'JPEG', 0, 0, width, height);
          pdf.save(fileName);
        } else {
          const anchorEl = document.createElement('a');
          anchorEl.setAttribute('download', fileName);
          anchorEl.setAttribute('href', image);
          anchorEl.click();
        }
      }
    });

    dispatch(addPositiveToast(`Exporting as ${type}...`));
  };

  return (
    <OverflowMenu
      id="overflow-menu-dropdown"
      options={[
        {
          as: AllowedActionMenuElements.Title,
          content: 'Additional actions',
          id: 'additional-actions-title',
        },
        {
          as: AllowedActionMenuElements.Button,
          id: 'settings',
          content: 'Open settings',
          onClick: () => openSettingsModal(),
        },
        {
          as: AllowedActionMenuElements.Title,
          content: 'Export dashboard as...',
          id: 'export-actions-title',
        },
        {
          as: AllowedActionMenuElements.Button,
          id: 'pfd',
          content: 'PDF',
          onClick: () => onExport('pdf'),
        },
        {
          as: AllowedActionMenuElements.Button,
          id: 'png',
          content: 'PNG',
          onClick: () => onExport('png'),
        },
        {
          as: AllowedActionMenuElements.Button,
          id: 'jpeg',
          content: 'JPEG',
          onClick: () => onExport('jpeg'),
        },
      ]}
    />
  );
};
